import angular from "angular";
import ocLazyLoad from "oclazyload";

import LocaleService from "app/services/LocaleService";
import uibCollapse from "angular-ui-bootstrap/src/collapse/collapse";

import dcNavigation from "./dc-navigation";
import dcPageContainer from "./dc-page-container";
import dcSidebarCollapse from "./dc-sidebar-collapse";
import dcMainMenuCollapse from "./dc-main-menu-collapse";

import MenuService from "modules/dcb-eaccount/services/MenuService";
import matchmedia from "matchmedia-ng";

export default angular.module("dc-ui.dc-navigation",[ocLazyLoad,LocaleService,MenuService,"ui.bootstrap.collapse","matchmedia-ng"])
  .directive("dcNavigation",dcNavigation)
  .directive("dcPageContainer",dcPageContainer)
  .directive("dcSidebarCollapse",dcSidebarCollapse)
  .directive("dcMainMenuCollapse",dcMainMenuCollapse)
  .name;



// WEBPACK FOOTER //
// ./src/ui/modules/dc-ui/dc-navigation/index.js